import BaseService from './base.service';

class MailingListsService extends BaseService {
    constructor() {
        super('/api/v2/public/mailing-list-subscriptions');
    }

    addToMailingList(data) {
        return this.post('', data);
    }
}

export default new MailingListsService();
